import React, { useState, useEffect, useContext } from "react";
import axiosInstance from "../utills/axiosInstance";
import "./EmployeeDashboard.css";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
import { Usercontext } from "../../App";
import axios from "axios";
import { usePermissions } from "../utills/usePermissions";
import { Alert } from "@mui/material";

const EmployeeDashboard = () => {
  const { setTitle } = useContext(Usercontext);
  const navigate = useNavigate();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  const { canView, canCreate, canEdit, canDelete, loading: permissionsLoading } = usePermissions();

  useEffect(() => {
    const fetchImages = async () => {
      setLoading(true);
      const token = localStorage.getItem("token");

      if (!token) {
        console.log("No token available, redirecting to login");
        navigate("/");
        return;
      }

      try {
        const { data } = await axiosInstance.get(
          `${process.env.REACT_APP_BACKEND_URL ?? window.location.origin}/api/images`);
        setImages(data);
      } catch (error) {
        console.error("Error fetching images:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  const handleDelete = async (id) => {
    const userConfirmed = window.confirm(
      "Are you sure you want to delete this image? Click OK to proceed."
    );

    if (userConfirmed) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_URL ?? window.location.origin}/api/images/${id}`,
          {
            headers: {
              "Authorization": `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setImages(images.filter(image => image._id !== id));
      } catch (error) {
        console.error("Error deleting image:", error);
      }
    } else {
      console.log("Image deletion was canceled by the user.");
    }
  };

  const handleEdit = (image) => {
    setTitle(image);
    navigate("/employee");
  };

  const handleView = (image) => {
    setTitle(image);
    navigate("/employee/details");
  };

  const handleAddEmployee = () => {
    navigate("/employee");
  };

  if(!permissionsLoading && !canView('employee')){
    return (
      <div>
        <Alert severity="warning">Insufficient permissions to view emoployee.</Alert>
      </div>
    )
  }

  return (
    <>
      <div className="app-container">
        <h1 className="heading">Employee List</h1>

        {
          canCreate('employee') && (
            <div className="button-container">
              <button className="add-employee-btn" onClick={handleAddEmployee}>
                Add Employee
              </button>
            </div>
          )
        }

        {loading ? (
          <div>Loading...</div>
        ) : (
          <table className="image-table">
            <thead>
              <tr>
                <th>Employee ID</th>
                <th>Employee Name</th>
                <th>Department</th>
                <th>Designation</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {images.map((image, index) => (
                <tr key={image._id}>
                  <td>{image.empId}</td>
                  <td>{image.firstName}</td>
                  <td>{image.department}</td>
                  <td>{image.designation}</td>
                  <td className="action">
                    <button className="view-btn" onClick={() => handleView(image)}>
                      <FaEye />
                    </button>
                    {
                      canEdit('employee') && (
                        <button className="edit-btn" onClick={() => handleEdit(image)}>
                          <FaEdit />
                        </button>
                      )
                    }
                    {
                      canDelete('employee') && (
                        <button className="delete-btn" onClick={() => handleDelete(image._id)}>
                          <FaTrash />
                        </button>
                      )
                    }
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
};

export default EmployeeDashboard;
